import classofRaw from './classof-raw.js';
import global$1 from './global.js';

var classof = classofRaw;
var global = global$1;
var engineIsNode = classof(global.process) == 'process';

export { engineIsNode as default };
